import React from 'react'

import PropTypes from 'prop-types'
import classNames from 'classnames'

import FormControl from './FormControl'

export default class TextAreaInput extends FormControl {
  static propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    helpText: PropTypes.string,
    disabled: PropTypes.bool,
    validationFuncs: PropTypes.array,
    initialValue: PropTypes.string,
    maxChars: PropTypes.number,
    rows: PropTypes.number,
    formGroupClass: PropTypes.string,
    minChars: PropTypes.number
  }

  static defaultProps = {
    disabled: false,
    validationFuncs: [],
    initialValue: '',
    maxChars: 10000,
    rows: 10
  }

  getValue() {
    return this.state.value
  }

  render() {
    const { id, label, labelClass, placeholder, disabled, helpText, maxChars, rows, formGroupClass, minChars } = this.props
    const { isValid, value, errorMessage } = this.state

    const groupClass = classNames({
      'form-group': !this.props.isGroup ? this.props.isGroup : true,
      'has-danger': !isValid,
      [formGroupClass]: !!formGroupClass
    })

    const widgetClass = classNames({
      'form-control': true,
      'form-control-danger': !isValid
    })

    const labelClassName = classNames({
      [labelClass]: !!labelClass
    })

    return (
      <fieldset className={groupClass}>
        {label && (
          <label className={labelClassName} htmlFor={id}>
            {label}
          </label>
        )}
        <div className="text-area-input__wrapper">
          <textarea
            ref={id}
            className={widgetClass}
            id={id}
            placeholder={placeholder}
            disabled={disabled}
            onBlur={this.validate}
            onChange={this.handleChange}
            value={value}
            maxLength={maxChars}
            rows={rows}
          />
          {maxChars && (
            <span className="text-area-input__counter">
              {value != null ? value.length : 0} / {maxChars}
            </span>
          )}
        </div>
        {helpText && <small className="text-muted">{helpText}</small>}
        {errorMessage && <small className="text-danger">{errorMessage}</small>}
      </fieldset>
    )
  }
}



// WEBPACK FOOTER //
// src/components/UI/TextAreaInput.jsx